import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// Material-UI
import MuiDrawer from '@material-ui/core/Drawer';
import MuiList from '@material-ui/core/List';
import MuiListHeader from '@material-ui/core/ListSubheader';
import MuiListItem from '@material-ui/core/ListItem';
import MuiListItemText from '@material-ui/core/ListItemText';

import { Lines } from '@components';
import { MUI } from '@styles';

const Sidebar = (props) => {
  return (
    <>
      <Styled.Drawer open={props.open} onClose={() => props.onSidebarToggle()}>
        <MUI.Box display="flex" width="100%" height="100%">
          <Styled.List>
            <Styled.ListHeader>
              <Styled.AppName>
                {props.appName}
              </Styled.AppName>
            </Styled.ListHeader>
            <MUI.Divider />
            {props.sidebarChildren ? (
              props.sidebarChildren
            ) : props.sidebarActions.map((action, index) => {
              return (
                <Styled.ListItem
                  button
                  key={index}
                  onClick={() => props.history.push(action.route)}
                >
                  <Styled.ListItemText primary={action.label} />
                </Styled.ListItem>
              );
            })}
          </Styled.List>
          <Lines
            direction="vertical"
            firstLine={{ size: 50, color: 'purple' }}
            secondLine={{ size: 50, color: 'blueDark' }}
          />
        </MUI.Box>
      </Styled.Drawer>
    </>
  );
};

Sidebar.propTypes = {
  // Boolean que indica si esta abierto el menú lateral.
  open: PropTypes.bool.isRequired,
  // History router.
  history: PropTypes.object,
  // El nombre de aplicación en la que se encuentra.
  appName: PropTypes.string.isRequired,
  // Array de acciones del menú lateral.
  sidebarActions: PropTypes.array,
  // Componente de React dentro del Drawer.
  sidebarChildren: PropTypes.node,
  // Función para desplegar el menú lateral.
  onSidebarToggle: PropTypes.func
};

// *************************************
// STYLED COMPONENTS                               
// *************************************

const Styled = {};

Styled.Drawer = styled(MuiDrawer)`
  .MuiDrawer-paperAnchorLeft {
    top: 64px;
  }

  .MuiBackdrop-root {
    top: 64px;
  }

  &.MuiDrawer-root {
    top: 64px !important;
    width: 250px;
  }
`;

Styled.AppName = styled.div`
  margin: 0 8px;
`;

Styled.List = styled(MuiList)`
  &.MuiList-root {
    padding: 0px;
  }    
`;

Styled.ListHeader = styled(MuiListHeader)`
  &.MuiListSubheader-root {
    font-family: 'Bryant Pro Medium';
    font-size: ${(props) => props.theme.typography.bodyText};
    font-weight: normal;
    line-height: normal;
    letter-spacing: normal;
    color: ${(props) => props.theme.colors.greyDark};
    text-decoration: none;
    display: flex;
    min-height: 50px;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
`;

Styled.ListItem = styled(MuiListItem)`
  &.MuiListItem-root {
    min-height: 50px;
    padding: 0px 16px;
  }
`;

Styled.ListItemText = styled(MuiListItemText)`
  .MuiTypography-root {
    font-family: 'Bryant Pro Regular';
    font-size: ${(props) => props.theme.typography.bodyText};
    font-weight: normal;
    line-height: normal;
    letter-spacing: normal;
    color: ${(props) => props.theme.colors.greyDark};
    text-decoration: none;
  }
`;

export default Sidebar;